export interface PopupOptions {
  popupOpenMode?: PopupOpenModeEnum;
  popupType?: PopupTypeEnum;

}

export enum PopupOpenModeEnum {
  onMarkerClick,
  onMarkerMouseOver,
  none
}

export enum PopupTypeEnum {
  default = 'default',
  leafletLike = 'leafletLike'
}

